import React, { useEffect, useRef, useState } from 'react';

function CoPilotIframe() {
  const containerRef = useRef(null);
  const iframeRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    const fullscreenEnabled =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement;
    const exitFullscreen = () => {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen(); // Firefox
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen(); // Chrome, Safari, Opera
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    };

    const enterFullscreen = () => {
      if (containerRef.current.requestFullscreen) {
        containerRef.current.requestFullscreen();
      } else if (containerRef.current.mozRequestFullScreen) {
        containerRef.current.mozRequestFullScreen(); // Firefox
      } else if (containerRef.current.webkitRequestFullscreen) {
        containerRef.current.webkitRequestFullscreen(); // Chrome, Safari, Opera
      } else if (containerRef.current.msRequestFullscreen) {
        containerRef.current.msRequestFullscreen();
      }
    };
    if (fullscreenEnabled) {
      exitFullscreen();
    } else {
      enterFullscreen();
    }
  };
  useEffect(() => {
    const handleEvent = (event) => {
      if (event.origin !== 'https://app.algobulls.com') {
        return;
      }
      if (event.data === 'toggleFullscreen') {
        toggleFullscreen();
      }
    };

    const handleScreenChange = () => {
      if (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      ) {
        iframeRef?.current.contentWindow.postMessage(
          { isFullscreen: true },
          '*',
        );
        setIsFullscreen(true);
      } else {
        iframeRef?.current.contentWindow.postMessage(
          { isFullscreen: false },
          '*',
        );
        setIsFullscreen(false);
      }
    };
    window.addEventListener('fullscreenchange', handleScreenChange);
    window.addEventListener('message', handleEvent);
    return () => {
      window.removeEventListener('message', handleEvent);
      window.removeEventListener('fullscreenchange', handleScreenChange);
    };
  }, []);

  return (
    <section className="pad100">
      <div className="container">
        <div className="iframeContainer">
          <div
            ref={containerRef}
            id="iframeContainer"
            className={`iframe-title-container ${isFullscreen ? 'fullscreen' : ''}`}>
            <div className="displayTitle-ai ">
              <h3 className="text-gradient" id="tryCopilot">
                Try Phoenix Copilot Now - No Login Required !
              </h3>
            </div>
            <p>
              Experience the future of Algo Trading. It&apos;s easy to get
              started. Chat with our AI now and backtest your first trading idea
              <span
                style={{
                  display: 'inline-block',
                  transform: 'translateY(8px)',
                }}>
                👇
              </span>
            </p>
            <div className="phoenix-copilot-container" id="CoPilotIframe">
              <iframe
                ref={iframeRef}
                title="phoenix-copilot"
                src="https://app.algobulls.com/phoenix-copilot/guest"
                height="100%"
                width="100%"
                allow="clipboard-write"></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CoPilotIframe;
